import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Курси',
    href: '#courses'
  }, {
    name: 'Роботи',
    href: '#gallery'
  }, {
    name: 'Про мене',
    href: '#about'
  }, {
    name: 'Контакти',
    href: '#footer'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white py-4 border-b border-gray-100' : 'bg-transparent py-6'}`} data-id="element-155">
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-156">
        <div className="flex flex-col" data-id="element-157">
          <span className="font-heading text-2xl font-semibold tracking-wide text-dark" data-id="element-158">
            Валентина
          </span>
          <span className="text-[10px] uppercase tracking-widest text-gray-500" data-id="element-159">
            майстер-перукар
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-160">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-800 hover:text-accent transition-colors" data-id="element-161">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:block" data-id="element-162">
          <a href="#contact" className="px-6 py-2.5 bg-dark text-white text-xs font-medium tracking-widest uppercase hover:bg-black transition-colors" data-id="element-163">
            Записатися
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-164">
          {isMobileMenuOpen ? <X size={24} data-id="element-165" /> : <Menu size={24} data-id="element-166" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-gray-100 shadow-sm py-4 px-6 flex flex-col space-y-4" data-id="element-167">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-gray-800 hover:text-accent transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-168">
              {link.name}
            </a>)}
          <a href="#contact" className="inline-block text-center px-6 py-3 bg-dark text-white text-xs font-medium tracking-widest uppercase hover:bg-black transition-colors mt-4" onClick={() => setIsMobileMenuOpen(false)} data-id="element-169">
            Записатися
          </a>
        </div>}
    </header>;
}